<template>
    <transition name="slide-fade" >
      <div>
        <div class="uk-padding">
            <div class="uk-container uk-container-small">
                <h1 class="uk-heading-line uk-text-center"><span>Financial Management Services</span></h1>
                <h3 class="uk-heading-bullet h2Style">Complete outsourced Financial Controller and CFO services</h3>
                <p>
                    Not all businesses can afford a full-time Controller or Chief Financial
                    Officer. When you outsource your finance function to us, it reduces
                    cost and allows you to pay for only the services you need. Why worry
                    about vacation, sick leave, rollovers, pension and other personnel
                    issues. With a winning team on your side, we will make accounting for
                    your business hassle free so that your time can be optimally used to
                    focus on other strategic growth areas.
                </p>
                <p>
                    At FINCOR, we provide experienced, licensed, insured and fully
                    qualified accountants and other professionals at a fraction of the cost
                    of hiring in-house. We will work with your business as a trusted partner
                    in providing financial management, advisory services and effective
                    solutions.
                </p>
                <p>
                    As a boutique firm, we provide personalized service that truly delivers
                    value for money. You will have the benefit of expert knowledge and
                    advice to take your business in the right direction, while reducing the
                    day-to-day hassles of an in-house accounting Department.
                </p>
                <ul class="uk-list uk-list-bullet">
                    Our accounting and financial controller services include:
                    <li>Budgeting, forecasting, and projections;</li>
                    <li>Strategic Planning;</li>
                    <li>Analysis and advice on management information;</li>
                    <li>Monthly financial close;</li>
                    <li>Financial Analysis and Reporting;</li>
                    <li>Oversight of back office and accounting staff work;</li>
                    <li>Assistance with complex accounting issues;</li>
                    <li>Data cleanup;</li>
                    <li>Cash flow analysis and reporting;</li>
                    <li>Financial Statement Compilation; and</li>
                    <li>Preparation of management and Board reporting packages.</li>
                </ul>
              <router-link to="/blogs/focusing-on-what-really-matters-and-saving-money-in-the-process"><span uk-icon="info" style="margin-right: 5px"></span>Click here to read our latest blog post on this topic</router-link>

            </div>

        </div>
      <ContactStrip />
      </div>
    </transition>
</template>

<script>
    import ContactStrip from "@/components/parts/ContactStrip.vue";

    export default {
        name: "financialManagement",
      components: {ContactStrip},
      metaInfo: {
        title: ' Financial Management Services',
        meta: [{
          content: 'At FINCOR, we provide experienced, licensed, insured and fully qualified accountants and other professionals at a fraction of the cost of hiring in-house. We will work with your business as a trusted partner in providing financial management, advisory services and effective solutions.'
        }]
      }
    }
</script>

<style scoped>
    .h2Style{
        font-family: 'Overlock SC';
    }
</style>